// extracted by mini-css-extract-plugin
module.exports = {"about":"About_about__3YX6G","about__thumb":"About_about__thumb__1L56n"};